import React from "react";
import { useMediaQuery, useTheme } from "@material-ui/core";
import Button from "@material-ui/core/Button";
import AddIcon from "@material-ui/icons/Add";
import { languages } from "../constants/languages";

const CreateTournamentButton = (props) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("xs"));

  return (
    <Button
      variant="outlined"
      color="default"
      onClick={props.handleCreate}
      startIcon={<AddIcon />}
    >
      {isMobile
        ? languages.general.add
        : languages.createTournament.createTournament}
    </Button>
  );
};

export default CreateTournamentButton;
